import React from 'react';

import { IconButton, Menu, MenuItem } from '@mui/material';

import MoreVertIcon from '@mui/icons-material/MoreVert';

interface RequestKebabMenuProps {
  canCancel: boolean;
  onCancel: () => void;
  onExport: () => void;
}

const RequestKebabMenu: React.FunctionComponent<RequestKebabMenuProps> = ({ canCancel, onCancel, onExport }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event: React.MouseEvent<HTMLElement>): void => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (): void => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton aria-label="acknowledgement-request-actions" aria-haspopup="menu" onClick={handleOpen}>
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose}>
        {canCancel && (
          <MenuItem
            id="cancel-acknowledgement-request"
            onClick={() => {
              handleClose();
              onCancel();
            }}
          >
            Cancel
          </MenuItem>
        )}
        <MenuItem
          id="export-acknowledgement-request"
          onClick={() => {
            handleClose();
            onExport();
          }}
        >
          Export evidence
        </MenuItem>
      </Menu>
    </>
  );
};

export default RequestKebabMenu;
